import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class DataProvider {
  constructor(public http: HttpClient) {}

  getSideMenusAuth() {
    return [
      { title: "Início", icon: "home", component: "HomePage" },
      { title: "Perfil", icon: "md-person", component: "ProfilePage" },
      {
        title: "Notificações",
        icon: "notifications",
        component: "NotificacoesPage",
      },
      {
        title: "Agendamentos",
        icon: "md-list-box",
        component: "HistoricoListPage",
      },
      // {
      //   title: "Exames",
      //   icon: "md-paper",
      //   component: "HistoricoExameListPage",
      // },
      // { title: "Meus Cartões", icon: "card", component: "ListaCartaoPage" },
      // {
      //   title: "Meus Voucher",
      //   icon: "filing",
      //   component: "ConsultaImedVoucherPage",
      // },
      // {title: 'Sobre', icon: 'clipboard', component: 'HomePage'},
    ];
  }

  getSideMenus() {
    return [
      { title: "Início", icon: "home", component: "HomePage" },
      //{title: 'Sobre', icon: 'clipboard', component: 'HomePage'},
    ];
  }
}



// WEBPACK FOOTER //
// ./src/providers/data/data.ts